import * as BrandTypes from './brand.types';
import {
  messageError,
  messageSuccess,
  messageWarning,
} from 'views/components/UI/message';
import { notificationErr } from 'views/components/UI/notification';
import { brandError } from 'utils/errorCodes';
import * as myBrandsApi from 'api/endpoints/myBrands/myBrands.api';
import {
  IBrandContactItemState,
  IBrandInfoState,
  IBrandTenantState,
} from 'interfaces/brand.interface';
import { IMyBrand } from 'interfaces/myBrands.interface';
import { TgetTenantPointsOfSaleAPIResponseItem } from 'api/endpoints/myBrands/myBrands.response.interface';
import { connected, disconnected, ITranslate } from 'interfaces/general.interface';
import { TbrandDispatchReducer } from './brand.reducer';

export async function getBrandAction({
  dispatch,
  clientId,
  brandId,
  tenantId,
  myBrands,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TbrandDispatchReducer>;
  clientId: string;
  brandId: string;
  tenantId: string;
  myBrands: IMyBrand[];
  token: string;
  translate: ITranslate;
}): Promise<boolean> {
  dispatch({ type: BrandTypes.SET_IS_LOADING, payload: true });
  try {
    const [brandFetch] = await Promise.all([
      myBrandsApi.getBrandsProfileAPI({ brandId, token }),
    ]);

    if (brandFetch.response.status === 200) {
      if (brandFetch.data?.tenants.length === 0) {
        dispatch({
          type: BrandTypes.SELECT_TENANT,
          payload: null,
        });
        const brand: IBrandInfoState = {
          ...brandFetch.data,
          tenants: [],
        };
        dispatch({
          type: BrandTypes.GET_BRAND_INFO,
          payload: brand,
        });
        return true;
      } else {
        let tenantsAssociated: IBrandTenantState[] = [];
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        for (const [index, myBrand] of myBrands.entries()) {
          const findTenant = brandFetch.data.tenants.find(
            (item) => item.id === myBrand.tenant_id
          );
          if (findTenant) {
            const [pointsOfSaleFetch, brandContactsFetch] = await Promise.all([
              myBrandsApi.getTenantPointsOfSaleAPI({
                clientId,
                tenantId: findTenant.id,
                token,
              }),
              myBrandsApi.getTenantContactsAPI({ tenantId: findTenant.id, token }),
            ]);
            // Get poits of sale
            let sortedPointsOfSale: Array<TgetTenantPointsOfSaleAPIResponseItem> = [];
            if (
              pointsOfSaleFetch.response.status === 200 &&
              pointsOfSaleFetch.data.length > 0
            ) {
              const sortPointsOfSale = pointsOfSaleFetch.data.sort((a, b) =>
                a.associated === b.associated ? 0 : a.associated ? -1 : 1
              );
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              for (const [index, item] of sortPointsOfSale.entries()) {
                sortPointsOfSale[index].key = index + 1;
              }
              sortedPointsOfSale = sortPointsOfSale;
            }
            // Get contacts
            let sortContacts: Array<IBrandContactItemState> = [];
            if (brandContactsFetch.response.status === 200) {
              const contacts = brandContactsFetch.data.company_tenant_contacts?.map(
                (item) => {
                  return {
                    ...item.contact,
                    key: item.contact.id,
                  };
                }
              );
              sortContacts = contacts;
            }
            let tenantAssociated: IBrandTenantState = {
              ...findTenant,
              associationState: connected,
              pointsOfSale: sortedPointsOfSale,
              contacts: sortContacts,
            };
            tenantsAssociated.push(tenantAssociated);
          }
        }

        const hydrateTenants = async () => {
          let tenantsArray: Array<IBrandTenantState> = [];
          for (const tenant of brandFetch.data.tenants) {
            const [pointsOfSaleFetch, brandContactsFetch] = await Promise.all([
              myBrandsApi.getTenantPointsOfSaleAPI({
                clientId,
                tenantId: tenant.id,
                token,
              }),
              myBrandsApi.getTenantContactsAPI({ tenantId: tenant.id, token }),
            ]);
            const findTenant = tenantsAssociated.find(
              (tenantAssociated) => tenantAssociated.id === tenant.id
            );
            // Get poits of sale
            let sortedPointsOfSale: Array<TgetTenantPointsOfSaleAPIResponseItem> = [];
            if (pointsOfSaleFetch.response.status === 200) {
              const sortPointsOfSale = pointsOfSaleFetch.data.sort((a, b) =>
                a.associated === b.associated ? 0 : a.associated ? -1 : 1
              );
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              for (const [index, item] of sortPointsOfSale.entries()) {
                sortPointsOfSale[index].key = index + 1;
              }
              sortedPointsOfSale = sortPointsOfSale;
            }
            // Get contacts
            let sortContacts: Array<IBrandContactItemState> = [];
            if (brandContactsFetch.response.status === 200) {
              const contacts = brandContactsFetch.data.company_tenant_contacts?.map(
                (item) => {
                  return {
                    ...item.contact,
                    key: item.contact.id,
                  };
                }
              );
              sortContacts = contacts;
            }
            tenantsArray.push({
              ...tenant,
              cif: !tenant.cif || tenant.cif === '0' ? '' : tenant.cif,
              address: !tenant.address || tenant.address === '0' ? '' : tenant.address,
              postal_code:
                !tenant.postal_code || tenant.postal_code === '0'
                  ? ''
                  : tenant.postal_code,
              city: !tenant.city || tenant.city === '0' ? '' : tenant.city,
              associationState: findTenant ? connected : disconnected,
              pointsOfSale: sortedPointsOfSale,
              contacts: sortContacts,
            });
          }
          return tenantsArray;
        };

        const hydratedTenants = await hydrateTenants();

        const brand: IBrandInfoState = {
          ...brandFetch.data,
          tenants: hydratedTenants,
        };

        const findTenant =
          tenantsAssociated.length > 0
            ? tenantsAssociated.find((tenant) => tenant.id === tenantId)
            : hydratedTenants.find((tenant) => tenant.id === tenantId);

        if (findTenant) {
          dispatch({
            type: BrandTypes.SELECT_TENANT,
            payload: findTenant,
          });
        }

        dispatch({
          type: BrandTypes.GET_BRAND_INFO,
          payload: brand,
        });
      }
      return true;
    } else {
      messageError(translate('action_brand_get-brand_error'));
      notificationErr(brandError.get_brand_002, translate);
      return false;
    }
  } catch (err) {
    messageError(translate('action_brand_get-brand_error'));
    notificationErr(brandError.get_brand_003, translate);
    return false;
  } finally {
    setTimeout(() => {
      dispatch({ type: BrandTypes.SET_IS_LOADING, payload: false });
    }, 200);
  }
}

export async function shareDataWithBrandAction({
  dispatch,
  datashareId,
  value,
  token,
  translate,
}: {
  dispatch: React.Dispatch<TbrandDispatchReducer>;
  datashareId: string;
  value: boolean;
  token: string;
  translate: ITranslate;
}): Promise<boolean> {
  try {
    const [shareDataFetch] = await Promise.all([
      myBrandsApi.shareDataWithBrandAPI({ datashareId, value, token }),
    ]);
    if (shareDataFetch.response.status === 403) {
      messageWarning(translate('not-authorized-warning'));
      return false;
    }
    if (shareDataFetch.response.status !== 200) {
      messageError(translate('action_brand_share-data-with-brand_error'));
      notificationErr(brandError.share_data_with_brand_002, translate);
      return false;
    }
    dispatch({
      type: BrandTypes.SHARE_DATA_WITH_BRAND,
      payload: {
        datashareId,
        value,
      },
    });
    value === true
      ? messageSuccess(translate('action_brand_share-data-with-brand_share-success'))
      : messageSuccess(translate('action_brand_share-data-with-brand_no-share-success'));
    return true;
  } catch (error) {
    notificationErr(brandError.share_data_with_brand_001, translate);
    return false;
  }
}
